import { useEffect, useState } from "react"
import { v4 as uuidv4 } from "uuid"
import { DEVICE_ID } from "constants/storages"

function useDeviceId() {
  const [deviceId, setDeviceId] = useState<string | null>(null)

  useEffect(() => {
    const existingId = localStorage.getItem(DEVICE_ID)
    if (existingId) {
      setDeviceId(existingId)
    } else {
      const newId = uuidv4()
      localStorage.setItem(DEVICE_ID, newId)
      setDeviceId(newId)
    }
  }, [])

  return deviceId
}

export default useDeviceId
